module.exports = __webpack_public_path__ + "static/img/470.0026ea2.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/470.gif
// module id = 3OxH
// module chunks = 1